import logo from './logo.svg';
import Navbar from './Navbar';
import Footer from './Footer';
import './App.css';
import Home  from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import CreateJob from './pages/CreateJob';
import Log from './pages/Log';
import CronManagement from './pages/CronManagement';
import Payment from './pages/Payment';
import ContactUs from './pages/ContactUs';
import Account from './pages/Account';
import Documentation from './pages/documentation';
import Pricing from './pages/Pricing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ResetPassword from './pages/ResetPassword'
import Verification from './pages/Verification';
import HealthCheck from './pages/HealthCheck';
import MCRPushHistory from './pages/MCRPushHistory';
import MCRManagement from './pages/MCRManagement';
import ConfigManagement from './pages/ConfigManagement';
import SecretManagement from './pages/SecretManagement';
import DeploymentManagement from './pages/DeploymentManagement';
import DomainManagement from './pages/DomainManagement';
import AutomationManagement from './pages/AutomationManagement';
import ClusterManagement from './pages/ClusterManagement';
import GitHubCallback from './pages/GitHubCallback';
import NotAuthorized from './pages/NotAuthorized';
import SeoArticle from './pages/SeoArticle';
import ProtectedRoute from "./functions/ProtectedRoute";
import TokenWatchdog from "./components/TokenWatchdog";
import SharedClusterGate from "./components/SharedClusterGate";
import GoogleAdsTag from "./components/GoogleAdsTag";
import useSeoHead from "./seo/useSeoHead";

import { Route, Routes, useLocation } from "react-router-dom";



function App(){

  const location = useLocation();

  // Keep the title, description, canonical and robots tag in step with the route
  // so client-side navigation matches the prerendered HTML.
  useSeoHead();

  const noHeaderFooterRoutes = ["/login", "/signup", "/verification", "/forgot-password", "/github/callback", "/not-authorized"];
  const shouldHideHeaderFooter = noHeaderFooterRoutes.includes(location.pathname);
  const isHome = location.pathname === "/";
  return ( 
    <div className={`app-wrapper${isHome ? ' is-home' : ''}`}>
      <TokenWatchdog />
      <GoogleAdsTag />
      {!shouldHideHeaderFooter && <Navbar />}
      <div className={`app-content${shouldHideHeaderFooter ? ' full-height' : ' with-nav'}`}>
        <div className="container"> 
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/pricing" element={<Pricing />} />
          {/* Public SEO landing pages, rendered from src/seo/pages.js. */}
          <Route path="/kubernetes-without-aws" element={<SeoArticle />} />
          <Route path="/batch-jobs" element={<SeoArticle />} />
          <Route path="/gpu-jobs" element={<SeoArticle />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/forgot-password" element={<Verification />} />
          <Route path="/health" element={<HealthCheck />} />
          <Route path="/github/callback" element={<GitHubCallback />} />
          <Route path="/not-authorized" element={<NotAuthorized />} />
          {/* Public: the form itself asks anonymous senders for an address and a
              challenge, and identifies signed-in ones from their token. */}
          <Route path="/contact" element={<ContactUs />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/create-job" element={<CreateJob />} />
            <Route path="/log" element={<Log />} />
            <Route path="/cron" element={<CronManagement />} />
            <Route path="/mcr/push-history" element={<MCRPushHistory />} />
            <Route path="/mcr/registry" element={<MCRManagement />} />
            <Route path="/deployment/config" element={<ConfigManagement />} />
            <Route path="/deployment/secrets" element={<SecretManagement />} />
            <Route path="/deployment/apps" element={<SharedClusterGate featureName="Deployment Management" browsable><DeploymentManagement /></SharedClusterGate>} />
            <Route path="/deployment/domains" element={<SharedClusterGate featureName="Domain Management" browsable><DomainManagement /></SharedClusterGate>} />
            <Route path="/cdci/automation" element={<SharedClusterGate featureName="Automation Management" browsable browsableNotice="Build Only pipelines run here. Build & Deploy needs your own cluster (Gold or Premium)."><AutomationManagement /></SharedClusterGate>} />
            <Route path="/cluster" element={<ClusterManagement />} />
            <Route path="/billing" element={<Payment />} />
            <Route path="/account" element={<Account />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
          </Route>

          
        </Routes>
        </div>
        {!shouldHideHeaderFooter && <Footer />}
      </div>
    </div>
  

  )
}

export default App;
